import picture from "../img/AboutMePicture.jpg"
export default function AboutMePicture() {
    return <div>
        <img className="aboutMePicture" src={picture} alt="aboutme-pic"/>
    </div>
}
